import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import Header from 'global/layout/header/Header'
import Footer from 'global/layout/footer/Footer'
import './Layout.scss'
import Modal from 'components/modal/Modal'
import GlobalScripts from 'global/GlobalScripts'
import { userContext } from 'global/context/sub-contexts/userContext'
import { getProfileInfo, tokenPresent } from 'services/profile'

import 'global/_css-variables.scss'
import 'site.scss'
import 'global/site-specific.scss'
import { StyledEngineProvider } from '@mui/material'
import analytics from 'global/AnalyticsData'

const Layout = ({ children, hideNav = false, hideFooter = false }) => {
  const user_context = useContext(userContext)
  const { logout, setProfile, setPoints, setSweepsEntries, isLoggedInBoolean } =
    user_context || {}

  useEffect(() => {
    if (isLoggedInBoolean || tokenPresent()) {
      getProfileInfo()
        .then(response => {
          const { user, sweepsEntries } = response.detail

          setProfile(user)
          setSweepsEntries(sweepsEntries)
          setPoints(user.points)

          analytics.setUser(user)
        })
        .catch(e => {
          logout()
          analytics.setUser({})
        })
    }
  }, [isLoggedInBoolean, tokenPresent])

  const inlineStyle = `
  .themed-button,
  .themed-button:hover {
      background-color : #4c3371;
      color : #fff;
      border-color : #4c3371; 
  }

  .themed-button-secondary {
    background-color : transparent;
    color : #fff;
    border : 2px solid #4c3371; 
  }

  .themed-secondary {
    background-color : #EEEAF4;
    color : #646464 ;
  }
  `

  return (
    <>
      <StyledEngineProvider injectFirst>
        <span className="shade"></span>
        <style dangerouslySetInnerHTML={{ __html: inlineStyle }} />
        <div id="drag-portal" />
        {!hideNav && <Header />}

        {children}

        {!hideFooter && <Footer />}
        <GlobalScripts />
        <Modal />
      </StyledEngineProvider>
      {/* <div id="embedPerceivedTop" style={{border: "1px solid #f00", height: "1px", width: "100%", position: "absolute", top:"var(--embedPerceivedTop)"}}/> */}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
